(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offer-sec-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".faq-items");

    faqItems.forEach(item => {
      const button = item.querySelector(".faq-questions");
      const icon = button.querySelector(".toggle-icons");

      button.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        faqItems.forEach(i => {
          i.classList.remove("active");
          i.querySelector(".toggle-icons").textContent = "+";
        });

        if (!isActive) {
          item.classList.add("active");
          icon.textContent = "–";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
